
import { CookieConsent } from '@/contexts/CookieConsentContext';

declare global {
  interface Window {
    fbq: any;
  }
}

export const loadMetaPixel = (consent: CookieConsent) => {
  // Only load Meta Pixel if marketing cookies are accepted
  if (!consent.marketing) {
    return;
  }

  // Check if Meta Pixel is already loaded
  if (window.fbq) {
    return;
  }

  // Load Meta Pixel script
  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '724224797010220');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);

  // Add noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=724224797010220&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
};

export const removeMetaPixel = () => {
  // Remove Meta Pixel if it exists
  if (window.fbq) {
    window.fbq = undefined;
  }
  
  // Remove script tags
  const scripts = document.querySelectorAll('script');
  scripts.forEach(script => {
    if (script.src && script.src.includes('fbevents.js')) {
      script.remove();
    }
  });
  
  // Remove noscript fallback
  const noscripts = document.querySelectorAll('noscript img[src*="facebook.com/tr"]');
  noscripts.forEach(img => {
    img.parentElement?.remove();
  });
};
